import { Translation } from '@ngx-translate/core';
import { DialogPassThrough } from 'primeng/dialog';

export const DialogTelekomPT = (tsKeys: Record<string, Translation>): DialogPassThrough => ({
  pcCloseButton: {
    root: { 'aria-label': tsKeys['PRIMENG'].aria.close },
  },
});
